import logo from './logo.svg';
import Additionofemp from './pages/Additionofemp/additionofemp';
import AdminClaimRequestForm from './pages/Claimrequest/claimrequest';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ClaimStatusScreen from './pages/Claimrequeststatus/claimrequeststatus';
import PolicyList from './pages/Policy-list/policy-list'
import LoginPage from './pages/Loginpage/login';
import DeleteEmployee from './pages/Deletionofemp/deletionofemp';
import EmployeeProfile from './pages/Employeeprofile/EmployeeProfile';
import InitialSetup from './pages/Initialsetup/initialsetup';
import SchemeList from './pages/hrdashboard/hrdashboard';
import ActiveEmployeeList from './pages/Activelistofemp/Activelist';
import AddUser from './pages/Adduser/Adduser';
import './App.css';
import HrDashboard from './pages/hrdashboard/hrdashboard';
import ProtectedRoute from './pages/ProtectedRoute/ProtectedRoute';
import OrgSetup from './pages/Organizationsetup/orgsetup';
import AddPolicy from './pages/Addpolicy/addpolicy';
import SetPrivileges from './pages/setprivilages/setprivilages';
import Organization from './pages/organization/organization';
import AddNewEmp from '../src/pages/addneemp/addnewemp';
import AddMember from '../src/pages/AddMember/AddMember';
import ManageEmployee from './pages/employeemanagement/employeemanagement';
import Elogin from './pages/Loginpage/login';
import ManageCDbalance from './pages/ManageCDbalance/managecdbalance';
import SuperAdminOrgSetup from './pages/createorg/CreateOrganization';
import EmployeeClaimStatusScreen from './pages/employeeClaims/employeeclaim';


function App() {
  return (
    <Router>
      <Routes>
        {/* Public route */}
        <Route path="/" element={<Elogin />} />
        {/* Protected routes */}
        <Route path="/additionofemployee" element={<Additionofemp />} />
        <Route path="/claimRequest" element={<AdminClaimRequestForm />} />
        <Route path="/claimstatus" element={<ClaimStatusScreen />} />
        <Route path="/policy-list" element={<PolicyList />} />
        <Route path="/deletionofemployee" element={<DeleteEmployee />} />
        <Route path="/employeeprofile" element={<EmployeeProfile />} />
        <Route path="/initial-setup" element={<InitialSetup />} />
        <Route path="/hr-dashboard" element={<HrDashboard />} />
        <Route path="/create-organzation" element={<SuperAdminOrgSetup />} />
        <Route path="/adduser" element={<AddUser />} />
        <Route path="/organization" element={<Organization />} />
        <Route path="/orgsetup" element={<OrgSetup />} />
        <Route path="/add-policy" element={<AddPolicy />} />
        <Route path="/set-privilages" element={<SetPrivileges />} />
        <Route path="/add-new" element={<AddNewEmp />} />
        <Route path="/add-member" element={<AddMember />} />
        <Route path="/manage-employee" element={<ManageEmployee />} />
        <Route path="/cd-balance" element={<ManageCDbalance />} />
        <Route path="/employee-claim" element={<EmployeeClaimStatusScreen />} />
      </Routes>
    </Router>
  );
}

export default App;